import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import ParentHeader from "../../parentHeader/ParentHeader";
import images from "../../../utilities/images/images";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format, addDays, subDays } from "date-fns";
import uiActions from "../../../redux/ui/action";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
// import "./StudentActivityContent.scss";
// import StudentActivityAttendance from "./StudentActivityAttendance";
import LoaderPopUp from "../../../components/loader/loader";
import StudentDayAttendanceContent from "./StudentDayAttendanceContent";

function StudentDayAttendance(props) {
  const { rollNo, startLoading, finishLoading, loginFromParent, loader } =
    props;

  const [attendanceData, setAttendanceData] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([]);
  const [visibleButtons, setVisibleButtons] = useState(11);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    generateDateRange(selectedDate);
    updateVisibleButtons();
    window.addEventListener("resize", updateVisibleButtons);
    return () => window.removeEventListener("resize", updateVisibleButtons);
  }, []);

  useEffect(() => {
    generateDateRange(selectedDate);
    getDayAttendanceDetails();
  }, [selectedDate]);

  const getDayAttendanceDetails = async () => {
    const formattedDate = format(new Date(selectedDate), "yyyy-MM-dd");
    const payload = {
      startDate: formattedDate,
      endDate: formattedDate,
      rollNo: rollNo,
    };

    startLoading();

    try {
      const response = await axios.post(
        "https://bg.mescray001.com/api/v1/zoom-attendance/get-student-attendance-datewise-mla",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        setAttendanceData(response.data);
      } else {
        setAttendanceData({});
      }
    } catch (error) {
      console.error("API Error:", error);
      setAttendanceData({});
    } finally {
      finishLoading();
    }
  };

  const generateDateRange = (date) => {
    const selectedDateObj = new Date(date);
    const startDate = subDays(selectedDateObj, 5);
    const range = Array.from({ length: 11 }, (_, i) => addDays(startDate, i));
    setDateRange(range);
  };

  const updateVisibleButtons = () => {
    const width = window.innerWidth;
    setVisibleButtons(width <= 768 ? 5 : 11);
  };

  const handleDateClick = (date) => setSelectedDate(date);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };
  const handleClickOutside = (e) => {
    if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
      setShowDatePicker(false);
    }
  };

  return (
    <>
      {loginFromParent }
      <div className="student-activity-wrapper" onClick={handleClickOutside}>
        <div className="container_grey_box">
          <div className="bckBtn-title">
            <Link className="backBtn" to="/parent-dashboard">
              <img src={images.m2_backBtn} alt="backBtn" />
            </Link>
            <div className="content-head">
              <h1>Student Attendance</h1>
              <div className="right">
                <img
                  src={images.calender}
                  alt="Choose the Date"
                  className="calendar-icon"
                  onClick={() => setShowDatePicker(!showDatePicker)}
                />
                <span className="text">Change Date</span>
                {showDatePicker && (
                  <div className="datepicker-container" ref={datePickerRef}>
                    <DatePicker
                      selected={new Date(selectedDate)}
                      onChange={handleDateChange}
                      dateFormat="dd/MM/yyyy"
                      maxDate={new Date()}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="date-range">
            {dateRange.slice(0, visibleButtons).map((date, index) => (
              <button
                key={index}
                onClick={() => handleDateClick(date)}
                className={
                  selectedDate.toDateString() === date.toDateString()
                    ? "active"
                    : ""
                }
              >
                {format(date, "dd MMM")}
              </button>
            ))}
          </div>
          <StudentDayAttendanceContent
          attendanceData={attendanceData}
          selectedDate={selectedDate}
        />
        </div>

        
      </div>

      {loader && <LoaderPopUp />}
    </>
  );
}

const mapStateToProps = (state) => ({
  loader: state.ui.loader,
  rollNo: state.parentrootReducer.parentAuthReducer.user.st_rollno,
  loginFromParent: state.parentrootReducer.parentAuthReducer.loginFromParent,
});

const mapDispatchToProps = (dispatch) => ({
  startLoading: () => dispatch(uiActions.startLoading()),
  finishLoading: () => dispatch(uiActions.finishLoading()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentDayAttendance);
